import { LucideProvider } from 'lucide-react'
import type { PropsWithChildren } from 'react'

import { useIconSizes } from 'src/hooks'

export const LucideThemeProvider = ({ children }: PropsWithChildren) => {
  const { default: defaultIconSize } = useIconSizes()

  return <LucideProvider size={defaultIconSize}>{children}</LucideProvider>
}
